import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogContent,
  MatDialogRef,
} from '@angular/material/dialog';
import { SingleActionDialogModel } from '../../../interfaces/dialogs/single-action-dialog.model';
import { MatButton } from '@angular/material/button';

/**
 * 單一按鈕通用dialog組件，對應樣式A
 */
@Component({
  selector: 'app-single-action-dialog',
  standalone: true,
  imports: [MatDialogContent, MatButton],
  templateUrl: './single-action-dialog.component.html',
  styleUrl: './single-action-dialog.component.scss',
})
export class SingleActionDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<SingleActionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SingleActionDialogModel
  ) {}

  close() {
    if (this.data.closeAction) {
      this.data.closeAction();
    } else {
      this.dialogRef.close();
    }
  }
}
